import 'css-chunksrc/client/scenes/workloads/wbs/list/dateForm/styles.scss';export default {
  "dateForm": "_dateForm_rwjjg_1",
  "input": "_input_rwjjg_5",
  "readOnly": "_readOnly_rwjjg_12",
  "disabled": "_disabled_rwjjg_18"
};